<template>
    <div class="modal-mask hyper-modal" :class="[modalMaskClass]" v-if="value" transition="modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header modal-colored-header" :class="[modalHeaderClass]">
                    <slot name="header"></slot>
                    <button
                        @click="dismiss()"
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-hidden="true"
                    >×</button>
                </div>

                <div class="modal-body">
                    <slot name="body"></slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer">
                        <button
                            @click="dismiss()"
                            type="button"
                            class="btn btn-light"
                            data-dismiss="modal"
                        >Close</button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import Modal from "./Modal";
export default {
    props: {
        modalClass: {
            default: "info",
        },
        value: {
            type: Boolean,
        },
    },
    methods: {
        dismiss() {
            this.$emit("input", false);
        },
    },
    computed: {
        modalMaskClass() {
            return this.modalClass + "-header-modal";
        },
        modalHeaderClass() {
            return "bg-" + this.modalClass;
        },
    },
};
</script>

<style lang="scss">
.modal-mask {
    display: flex;
    align-items: center;
    justify-content: center;

    &.size-sm {
        .modal-dialog {
            width: 300px;
        }
    }
    &.size-md {
        .modal-dialog {
            width: 500px;
        }
    }
    &.size-lg {
        .modal-dialog {
            width: 800px;
            max-width: 800px;
        }
    }
}
</style>